import sectionCountdownHurryBoxCss from '../css-snippets/section-countdown-hurry-box';

const html = `
<style>${sectionCountdownHurryBoxCss}</style>
     <div id="card-container-unique-id" data-id="unique-id" data-attribute="section-countdown-hurry-box">
        <div class="left-in-stock" data-attribute="left-in-stock">
            <img src="https://cdn.skyfastimg.com/assets/image/icon-fire.gif" alt="">
            Hurry! Only <strong data-attribute="left-in-stock-number"> 10 </strong> left in stock
        </div>
        <div class="people-are-viewing" data-attribute="people-are-viewing">
            <img src="https://cdn.skyfastimg.com/assets/image/icon-point-pro.gif" alt="">
            <strong data-attribute="people-are-viewing-number">1024</strong>
            People are viewing this right now
        </div>
        <div class="last-minute-sale-end-in" data-attribute="last-minute-sale-end-in" data-value="10">
            <span>
                <strong>Last Minute</strong> - Sale end in
            </span>
            <strong class="time-countdown">
                <span data-attribute="minute">
                    10
                </span>:
                <span data-attribute="second">00</span>
            </strong>
        </div>
    </div>
    
`;
export default html;
